import { render, staticRenderFns } from "./CustomerDisplayButton.vue?vue&type=template&id=2ea7b91b&scoped=true&"
import script from "./CustomerDisplayButton.vue?vue&type=script&lang=js&"
export * from "./CustomerDisplayButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDisplayButton.vue?vue&type=style&index=0&id=2ea7b91b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7b91b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
